// eslint-disable-next-line no-unused-vars
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import basicStatApi from './basicStat.api';
import { handleThunkException } from '~/services/thunk.service';
// eslint-disable-next-line no-unused-vars
import { showToast, fakeSuccessResponse, fake422Response } from '~/utils/helpers';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';

export const fetchBasicStatApi = createAsyncThunk(
    'heroSaga/basicStat/fetchBasicStatApi',
    async (navigate, { dispatch, rejectWithValue }) => {
        try {
            dispatch(requestStarted());
            const data = await basicStatApi.index();

            if (data) {
                dispatch(requestFinished());
                return data;
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue([]);
        }
    },
);

export const updateBasicStatApi = createAsyncThunk(
    'heroSaga/basicStat/updateBasicStatApi',
    async (params, { dispatch, getState, rejectWithValue }) => {
        const { navigate } = params;
        const state = getState();
        const editedRow = state.heroSaga.basicStat.editedRow;

        try {
            dispatch(requestStarted());

            await basicStatApi.update(editedRow);

            showToast('Basic Stat updated successfully!');

            dispatch(clearApiValidationErrors());
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue();
        } finally {
            dispatch(requestFinished());
        }
    },
);

export const basicStatSlice = createSlice({
    name: 'heroSaga/basicStat',
    initialState: { rows: [], editedRow: {} }, //model is initialValues that are used for formik.
    reducers: {
        edit(state, { payload }) {
            state.editedRow = payload;
        },

        cancelEdit(state) {
            state.editedRow = {};
        },

        update(state, { payload }) {
            state.editedRow = payload;
        },

        save(state) {
            state.rows.forEach((item, i, arr) => {
                if (item.id === state.editedRow.id) {
                    arr[i] = state.editedRow;
                }
            });
            state.editedRow = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBasicStatApi.fulfilled, (state, { payload }) => {
                return {
                    ...state,
                    rows: payload,
                };
            })
            .addCase(fetchBasicStatApi.rejected, (state, { payload = [] }) => {
                state.rows = payload;
            });

        builder
            .addCase(updateBasicStatApi.fulfilled, (state) => {
                state.rows.forEach((item, i, arr) => {
                    if (item.id === state.editedRow.id) {
                        arr[i] = state.editedRow;
                    }
                });
                state.editedRow = {};
            })
            .addCase(updateBasicStatApi.rejected, () => {
                //do nothing so that state will remain intact and component will not re-render.
            });
    },
});
export const { edit, cancelEdit, save, update } = basicStatSlice.actions;
